export default __webpack_public_path__ + "static/media/english-to-korean-screenshot-05.5b32a82d.png";